<template>
  <section id="Contas" class="section-item">
    <h1>{{ $t("title.accounts") }}</h1>

    <section id="api-Contas-GetAccountsInfo">
      <h2>{{ $t("title.account_information") }}</h2>
      <p>{{ $t("accounts.view_account_info_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/accounts/info</code></pre>
      </div>
      <div class="code-toggle">
        <button class="curl">
          {{ $t("general.authenticated_request_example") }}
        </button>
      </div>

      <pre>
        <code class="language-bash">curl -XGET -H "Content-type: application/json" 'https://{{ whitelabel?.api_domain }}/v1/accounts/info'
-u '[SEU ID]:[SEU TOKEN]'</code>
      </pre>

      <h3>{{ $t("general.authentication") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>
              {{ $t("general.default_value") }}:
              <span class="app-json">application/json</span>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>{{ $t("general.success_200") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("account.account_id") }}</td>
          </tr>
          <tr>
            <td>auth_token</td>
            <td>String</td>
            <td>{{ $t("account.account_token") }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>String</td>
            <td>{{ $t("account.account_type") }}</td>
          </tr>
          <tr>
            <td>balance</td>
            <td>String</td>
            <td>{{ $t("account.account_balance") }}</td>
          </tr>
          <tr>
            <td>company_name</td>
            <td>String</td>
            <td>{{ $t("account.company_name") }}</td>
          </tr>
          <tr>
            <td>street</td>
            <td>String</td>
            <td>{{ $t("account.address") }}</td>
          </tr>
          <tr>
            <td>number</td>
            <td>String</td>
            <td>{{ $t("account.number") }}</td>
          </tr>
          <tr>
            <td>complement</td>
            <td>Object</td>
            <td>{{ $t("account.complement") }}</td>
          </tr>
          <tr>
            <td>district</td>
            <td>String</td>
            <td>{{ $t("account.neighborhood") }}</td>
          </tr>
          <tr>
            <td>city</td>
            <td>String</td>
            <td>{{ $t("account.city") }}</td>
          </tr>
          <tr>
            <td>province</td>
            <td>String</td>
            <td>{{ $t("account.state") }}</td>
          </tr>
          <tr>
            <td>postal_code</td>
            <td>String</td>
            <td>{{ $t("account.zip_code") }}</td>
          </tr>
          <tr>
            <td>tax_id</td>
            <td>String</td>
            <td>{{ $t("account.fee_id") }}</td>
          </tr>
          <tr>
            <td>due_date</td>
            <td>String</td>
            <td>{{ $t("account.due_date") }}</td>
          </tr>
          <tr>
            <td>created_at</td>
            <td>String</td>
            <td>{{ $t("account.created_at") }}</td>
          </tr>
          <tr>
            <td>updated_at</td>
            <td>String</td>
            <td>{{ $t("account.updated_at") }}</td>
          </tr>
          <tr>
            <td>deleted_at</td>
            <td>String</td>
            <td>{{ $t("account.deleted_at") }}</td>
          </tr>
        </tbody>
      </table>

      <button class="btn02">{{ $t("general.success") }}</button>

      <pre>
        <code class="language-json">HTTP/1.1 200 OK
{
    "id": "2bfe159e-8357-4b5x-a948-b253bdd2907",
    "auth_token": "142d5ac3-753bc-7963-4ed3-4253b7x1541d",
    "name": "Sua conta",
    "type": "trial",
    "balance": "99.994",
    "company_name": null,
    "street": null,
    "number": null,
    "complement": null,
    "district": null,
    "city": null,
    "province": null,
    "postal_code": null,
    "tax_id": null,
    "due_date": null,
    "created_at": "2020-08-12T03:43:46.000000Z",
    "updated_at": "2020-08-12T12:58:34.000000Z",
    "deleted_at": null
}</code>
      </pre>

      <button class="btn02">{{ $t("general.error_response") }}</button>
      <pre>
        <code class="language-json">{
        "error": "Error message"
}</code>
      </pre>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "AccountsInfoComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
